import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const loops = defineConnector({
  identifier: "loops",
  name: "Loops",
  tagLine: "Email for SaaS products",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://app\\.loops\\.so/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Loops, go to [**Settings > API**](https://app.loops.so/settings?page=api) and click **Generate key**.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.loops.so/api/v1/api-key",
  },
});
